import {config} from '@/config'
import request from '@/utils/request'

export function getPayBankInfo(){
  return request({
      url:process.env.VUE_APP_BASE_URL_API+'/companyOrders/payInfo',
      method:'GET'
  })
}

export function offlinePay(data){
  return request({
      url:process.env.VUE_APP_BASE_URL_API+'/companyOrders/offlinePay',
      data
  })
}

export function pollingPayResult(orderNumber) {
    let url = `${process.env.VUE_APP_BASE_URL_API}/companyOrders/pay/${orderNumber}`
    return request({
        url,
        method: 'GET'
    })
}

export function qrcodePay(data) {
    return request({
        url:process.env.VUE_APP_BASE_URL_API+'/companyOrders/qrcodePay',
        data
    })
}
